export enum CrmType {
  Salesforce = 'salesforce',
}
